import React from "react";
import { FiFilter, FiX } from "react-icons/fi";
import CustomCheckBox from "../common/CustomCheckBox";

const categories = [
  { value: "desci_general", label: "DeSci General" },
  { value: "biotech_life_sciences", label: "Biotech & Life Sciences" },
  { value: "ai_computer_science", label: "AI & Computer Science" },
  { value: "open_source_software", label: "Open Source Software" },
  { value: "women_in_science", label: "Women in Science" },
  { value: "regional", label: "Regional" },
  { value: "climate_environment", label: "Climate & Environment" },
  { value: "space_astronomy", label: "Space & Astronomy" },
  { value: "other", label: "Other" },
];

const tiers = [
  { value: "bronze", label: "Bronze" },
  { value: "silver", label: "Silver" },
  { value: "gold", label: "Gold" },
  { value: "platinum", label: "Platinum" },
  { value: "custom", label: "Custom" },
];

const states = [
  { value: "active", label: "Active" },
  { value: "sold_out", label: "Sold Out" },
];

const CommunityFilters = ({
  filter,
  handleChangeFilter,
  handleRemoveFilter,
  onClose,
  isMobile = false,
}) => {
  const handleChangeCheckBox = (e, property, value) => {
    if (e.target.checked) {
      handleChangeFilter({ [property]: value }, true);
    } else {
      handleRemoveFilter({ [property]: value });
    }
  };

  const FilterSection = ({ title, children }) => (
    <div className="mb-6">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">{title}</h4>
      {children}
    </div>
  );

  const content = (
    <div className="flex flex-col gap-2">
      {/* Categories */}
      <FilterSection title="Category">
        <div className="flex flex-col gap-2">
          {categories.map((cat) => (
            <CustomCheckBox
              key={cat.value}
              id={`category-${cat.value}`}
              label={cat.label}
              checked={filter.category?.includes(cat.value)}
              onChange={(e) => handleChangeCheckBox(e, "category", cat.value)}
            />
          ))}
        </div>
      </FilterSection>

      {/* Membership Tiers */}
      <FilterSection title="Membership Tier">
        <div className="flex flex-col gap-2">
          {tiers.map((tier) => (
            <CustomCheckBox
              key={tier.value}
              id={`tier-${tier.value}`}
              label={tier.label}
              checked={filter.tier?.includes(tier.value)}
              onChange={(e) => handleChangeCheckBox(e, "tier", tier.value)}
            />
          ))}
        </div>
      </FilterSection>

      {/* State */}
      <FilterSection title="Status">
        <div className="flex flex-col gap-2">
          {states.map((state) => (
            <CustomCheckBox
              key={state.value}
              id={`state-${state.value}`}
              label={state.label}
              checked={filter.state?.includes(state.value)}
              onChange={(e) => handleChangeCheckBox(e, "state", state.value)}
            />
          ))}
        </div>
      </FilterSection>
    </div>
  );

  if (isMobile) {
    return (
      <div className="fixed inset-0 z-50 bg-black/50 flex justify-end">
        <div className="w-80 h-full bg-white p-6 overflow-y-auto animate-slide-in-right">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-lg font-bold flex items-center gap-2">
              <FiFilter />
              Filters
            </h3>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <FiX className="text-xl" />
            </button>
          </div>
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg">
      <h3 className="text-lg font-bold mb-6 flex items-center gap-2 text-gray-800">
        <FiFilter />
        Filters
      </h3>
      {content}
    </div>
  );
};

export default CommunityFilters;
